<div class="holiday-modal">
  <button class="close-btn" (click)="close()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>

  <div class="modal-header">
    <h1 class="title-text">Holiday Calendar {{ year }}</h1>
    <span class="cbre-brand">CBRE</span>
  </div>

  <div class="modal-body">
    <div *ngIf="loading" class="state-skeleton">
      <ngx-skeleton-loader
        [theme]="{ height: '38px', 'margin-bottom': '0', 'border-radius': '0' }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        count="14"
        [theme]="{ height: '32px', 'margin-bottom': '0', 'border-radius': '0' }"
      ></ngx-skeleton-loader>
    </div>
    <div *ngIf="errorMessage" class="state-msg error">{{ errorMessage }}</div>

    <table *ngIf="!loading && !errorMessage" class="holiday-table">
      <thead>
        <tr>
          <th class="th-light">Months</th>
          <th class="th-dark">Date</th>
          <th class="th-light">Day</th>
          <th class="th-dark th-wide">Holidays</th>
          <th class="th-light">Hyderabad</th>
          <th class="th-dark">Gurugram</th>
          <th class="th-light">Noida</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let group of groupedHolidays; let g = index">
          <tr *ngIf="g > 0" class="month-gap">
            <td colspan="7"></td>
          </tr>
          <tr *ngFor="let item of group.items" class="data-row">
            <td class="month-cell">{{ monthShort(item) }}</td>
            <td class="date-cell">{{ formatMonthDate(item) }}</td>
            <td>{{ item.dayName }}</td>
            <td class="holiday-name">{{ item.holidayName }}</td>
            <td class="city-cell">{{ item.hyderabad ? 'Yes' : '' }}</td>
            <td class="city-cell">{{ item.gurugram ? 'Yes' : '' }}</td>
            <td class="city-cell">{{ item.noida ? 'Yes' : '' }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div class="modal-footer">Digital &amp; Technology, India</div>
  </div>
</div>
